import type { LegacyReservationActionTarget } from "./legacyReservationActions"
import dayjs from "dayjs"
import { isSmartOmsReservation } from "./legacyReservationActions"

type DeadlineTarget = LegacyReservationActionTarget & {
  startTime?: string | number | Date | null
  overtime?: string | number | Date | null
}

export function reservationDeadlineText(reservation: DeadlineTarget): string {
  const central = isSmartOmsReservation(reservation)
  const value = central ? reservation.startTime : reservation.overtime
  if (value == null || value === "") return "待核实"
  const time = dayjs(value)
  if (!time.isValid()) return "待核实"
  return (central ? time.add(24, "hour") : time).format("YYYY-MM-DD HH:mm")
}
